module.exports = __webpack_public_path__ + "img/tp-7.200ae34d.png";